'use strict';

var RomSummaryDateRangeChartFilterFactory = function RomSummaryDateRangeChartFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['ROMSummaryCabinFilterFactory', 'ROMSummaryPOSFilterFactory', 'ROMSummaryDOWFilterFactory', 'ROMSummaryRomTimeBucketFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function RomSummaryDateRangeChartFilter() {
    DemandFilter.call(this, 'rom-summary-mode', 'summary-chart');
    this.registerFilters(injectedFilters);
  }
  RomSummaryDateRangeChartFilter.constructor = RomSummaryDateRangeChartFilter;
  RomSummaryDateRangeChartFilter.prototype = Object.create(DemandFilter.prototype);
  return RomSummaryDateRangeChartFilter;
};
RomSummaryDateRangeChartFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = RomSummaryDateRangeChartFilterFactory;